export default __webpack_public_path__ + "static/media/blackslider2.e3d6184a.png";